import { useQuery } from '@apollo/client';
import { Portfolio } from '@bakerweb/models';
import { GET_PORTFOLIOS } from '../graphql/queries/getPortfolios';

export const useGetPortfolios = (portfolioCodes?: string[], isMaster?: boolean) => {
  const { loading, error, data, refetch } = useQuery<{ portfolios: Portfolio[] }>(GET_PORTFOLIOS, {
    variables: { portfolioCodes, take: 5000, isMaster },
    fetchPolicy: 'cache-first'
  });

  const portfolios = data?.portfolios ?? [];

  return { loading, error, portfolios, refetch };
};
